{
  "defaultMessages.ACTIVE_DUTY": "现役军人",
  "defaultMessages.ARCHITECT": "建筑师",
  "defaultMessages.CHILD_CARE_WORKER": "托育服务人员",
  "defaultMessages.COMMUNITY_ELIGIBILITY_PROVISION": "CEP（社区资格条款，标题1/LAP）",
  "defaultMessages.DENTIST": "牙科医生",
  "defaultMessages.DOCTOR": "医生",
  "defaultMessages.EMT": "急救医疗技术员",
  "defaultMessages.FIREFIGHTER": "消防员",
  "defaultMessages.GENERAL_CONTRACTOR": "总承包商",
  "defaultMessages.GOLD_STAR_FAMILY": "金星家庭",
  "defaultMessages.GRADUATE": "毕业生",
  "defaultMessages.HOME_BUYER": "购房者",
  "defaultMessages.INTERIOR_DESIGNER": "室内设计师",
  "defaultMessages.LIBRARIAN": "图书管理员",
  "defaultMessages.LICENSED_COSMETOLOGIST": "持证美容师",
  "defaultMessages.LICENSED_REAL_ESTATE_AGENT": "持证房产中介",
  "defaultMessages.MILITARY_FAMILY": "军人家属",
  "defaultMessages.MILITARY_RETIREE": "军队退休人员",
  "defaultMessages.NURSE": "护士",
  "defaultMessages.NUTRITION_PROFESSIONAL": "营养专业人员",
  "defaultMessages.OTHER_GOVERNMENT_ASSISTANCE": "其他政府援助受益人",
  "defaultMessages.OTHER_HEALTH_WORKER": "其他医疗工作者",
  "defaultMessages.OTHER_MOVER": "其他搬运人员",
  "defaultMessages.PHARMACIST": "药剂师",
  "defaultMessages.POLICE": "警察",
  "defaultMessages.RESERVIST": "预备役或国民警卫队",
  "defaultMessages.SEARCH_AND_RESCUE": "搜救人员",
  "defaultMessages.SNAP_BENEFITS": "SNAP补贴受益人",
  "defaultMessages.STUDENT": "学生",
  "defaultMessages.VETERAN": "退伍军人或军队退休人员",
  "defaultMessages.VETERINARIAN": "兽医",
  "defaultMessages._EXPERIMENTAL.cvecNumberExplanation": "添加您的CVEC编号以提高即时验证的成功率。",
  "defaultMessages.activeDutyStartDate": "现役开始日期",
  "defaultMessages.address": "地址",
  "defaultMessages.addressPlaceholder": "地址",
  "defaultMessages.birthDate": "出生日期",
  "defaultMessages.branchOfService": "服役军种",
  "defaultMessages.branchOfServicePlaceholder": "服役军种",
  "defaultMessages.cantFindYourSchool": "找不到您的学校？点击查看提示",
  "defaultMessages.captchaFooterText": "Cloudflare将独立收集您的信息，用于与验证相关的欺诈预防目的，并依据其<cloudflarePrivacyPolicy>隐私政策</cloudflarePrivacyPolicy>使用相关信息。",
  "defaultMessages.changeLanguage": "更改语言",
  "defaultMessages.chooseCountry": "请在搜索前选择国家",
  "defaultMessages.city": "城市",
  "defaultMessages.cityPlaceholder": "城市",
  "defaultMessages.clearAndOpenMenu": "清除选择并打开菜单",
  "defaultMessages.clearSelection": "清除选择",
  "defaultMessages.close": "关闭",
  "defaultMessages.closeSection": "关闭部分",
  "defaultMessages.company": "公司",
  "defaultMessages.companyPlaceholder": "公司",
  "defaultMessages.copied": "已复制",
  "defaultMessages.countries.AD": "安道尔",
  "defaultMessages.countries.AE": "阿拉伯联合酋长国",
  "defaultMessages.countries.AF": "阿富汗",
  "defaultMessages.countries.AG": "安提瓜和巴布达",
  "defaultMessages.countries.AI": "安圭拉",
  "defaultMessages.countries.AL": "阿尔巴尼亚",
  "defaultMessages.countries.AM": "亚美尼亚",
  "defaultMessages.countries.AN": "荷属安的列斯",
  "defaultMessages.countries.AO": "安哥拉",
  "defaultMessages.countries.AR": "阿根廷",
  "defaultMessages.countries.AS": "美属萨摩亚",
  "defaultMessages.countries.AT": "奥地利",
  "defaultMessages.countries.AU": "澳大利亚",
  "defaultMessages.countries.AW": "阿鲁巴",
  "defaultMessages.countries.AZ": "阿塞拜疆",
  "defaultMessages.countries.BA": "波斯尼亚和黑塞哥维那",
  "defaultMessages.countries.BB": "巴巴多斯",
  "defaultMessages.countries.BD": "孟加拉国",
  "defaultMessages.countries.BE": "比利时",
  "defaultMessages.countries.BF": "布基纳法索",
  "defaultMessages.countries.BG": "保加利亚",
  "defaultMessages.countries.BH": "巴林",
  "defaultMessages.countries.BI": "布隆迪",
  "defaultMessages.countries.BJ": "贝宁",
  "defaultMessages.countries.BM": "百慕大",
  "defaultMessages.countries.BN": "文莱",
  "defaultMessages.countries.BO": "玻利维亚",
  "defaultMessages.countries.BR": "巴西",
  "defaultMessages.countries.BS": "巴哈马",
  "defaultMessages.countries.BT": "不丹",
  "defaultMessages.countries.BV": "布韦岛",
  "defaultMessages.countries.BW": "博茨瓦纳",
  "defaultMessages.countries.BY": "白俄罗斯",
  "defaultMessages.countries.BZ": "伯利兹",
  "defaultMessages.countries.CA": "加拿大",
  "defaultMessages.countries.CD": "刚果民主共和国",
  "defaultMessages.countries.CF": "中非共和国",
  "defaultMessages.countries.CG": "刚果共和国",
  "defaultMessages.countries.CH": "瑞士",
  "defaultMessages.countries.CI": "科特迪瓦",
  "defaultMessages.countries.CK": "库克群岛",
  "defaultMessages.countries.CL": "智利",
  "defaultMessages.countries.CM": "喀麦隆",
  "defaultMessages.countries.CN": "中国",
  "defaultMessages.countries.CO": "哥伦比亚",
  "defaultMessages.countries.CR": "哥斯达黎加",
  "defaultMessages.countries.CU": "古巴",
  "defaultMessages.countries.CV": "佛得角",
  "defaultMessages.countries.CW": "库拉索",
  "defaultMessages.countries.CY": "塞浦路斯",
  "defaultMessages.countries.CZ": "捷克共和国",
  "defaultMessages.countries.DE": "德国",
  "defaultMessages.countries.DJ": "吉布提",
  "defaultMessages.countries.DK": "丹麦",
  "defaultMessages.countries.DM": "多米尼克",
  "defaultMessages.countries.DO": "多米尼加共和国",
  "defaultMessages.countries.DZ": "阿尔及利亚",
  "defaultMessages.countries.EC": "厄瓜多尔",
  "defaultMessages.countries.EE": "爱沙尼亚",
  "defaultMessages.countries.EG": "埃及",
  "defaultMessages.countries.EH": "西撒哈拉",
  "defaultMessages.countries.ER": "厄立特里亚",
  "defaultMessages.countries.ES": "西班牙",
  "defaultMessages.countries.ET": "埃塞俄比亚",
  "defaultMessages.countries.FI": "芬兰",
  "defaultMessages.countries.FJ": "斐济",
  "defaultMessages.countries.FK": "福克兰群岛",
  "defaultMessages.countries.FM": "密克罗尼西亚",
  "defaultMessages.countries.FO": "法罗群岛",
  "defaultMessages.countries.FR": "法国",
  "defaultMessages.countries.GA": "加蓬",
  "defaultMessages.countries.GB": "英国",
  "defaultMessages.countries.GD": "格林纳达",
  "defaultMessages.countries.GE": "格鲁吉亚",
  "defaultMessages.countries.GF": "法属圭亚那",
  "defaultMessages.countries.GH": "加纳",
  "defaultMessages.countries.GI": "直布罗陀",
  "defaultMessages.countries.GL": "格陵兰",
  "defaultMessages.countries.GM": "冈比亚",
  "defaultMessages.countries.GN": "几内亚",
  "defaultMessages.countries.GP": "瓜德罗普（法属）",
  "defaultMessages.countries.GQ": "赤道几内亚",
  "defaultMessages.countries.GR": "希腊",
  "defaultMessages.countries.GS": "南乔治亚和南桑威奇群岛",
  "defaultMessages.countries.GT": "危地马拉",
  "defaultMessages.countries.GU": "关岛（美国）",
  "defaultMessages.countries.GW": "几内亚比绍",
  "defaultMessages.countries.GY": "圭亚那",
  "defaultMessages.countries.HK": "香港",
  "defaultMessages.countries.HM": "赫德岛和麦克唐纳群岛",
  "defaultMessages.countries.HN": "洪都拉斯",
  "defaultMessages.countries.HR": "克罗地亚",
  "defaultMessages.countries.HT": "海地",
  "defaultMessages.countries.HU": "匈牙利",
  "defaultMessages.countries.ID": "印度尼西亚",
  "defaultMessages.countries.IE": "爱尔兰",
  "defaultMessages.countries.IL": "以色列",
  "defaultMessages.countries.IN": "印度",
  "defaultMessages.countries.IO": "英属印度洋领地",
  "defaultMessages.countries.IQ": "伊拉克",
  "defaultMessages.countries.IR": "伊朗",
  "defaultMessages.countries.IS": "冰岛",
  "defaultMessages.countries.IT": "意大利",
  "defaultMessages.countries.JM": "牙买加",
  "defaultMessages.countries.JO": "约旦",
  "defaultMessages.countries.JP": "日本",
  "defaultMessages.countries.KE": "肯尼亚",
  "defaultMessages.countries.KG": "吉尔吉斯斯坦",
  "defaultMessages.countries.KH": "柬埔寨",
  "defaultMessages.countries.KI": "基里巴斯",
  "defaultMessages.countries.KM": "科摩罗",
  "defaultMessages.countries.KN": "圣基茨和尼维斯",
  "defaultMessages.countries.KP": "朝鲜",
  "defaultMessages.countries.KR": "韩国",
  "defaultMessages.countries.KW": "科威特",
  "defaultMessages.countries.KY": "开曼群岛",
  "defaultMessages.countries.KZ": "哈萨克斯坦",
  "defaultMessages.countries.LA": "老挝",
  "defaultMessages.countries.LB": "黎巴嫩",
  "defaultMessages.countries.LC": "圣卢西亚",
  "defaultMessages.countries.LI": "列支敦士登",
  "defaultMessages.countries.LK": "斯里兰卡",
  "defaultMessages.countries.LR": "利比里亚",
  "defaultMessages.countries.LS": "莱索托",
  "defaultMessages.countries.LT": "立陶宛",
  "defaultMessages.countries.LU": "卢森堡",
  "defaultMessages.countries.LV": "拉脱维亚",
  "defaultMessages.countries.LY": "利比亚",
  "defaultMessages.countries.MA": "摩洛哥",
  "defaultMessages.countries.MC": "摩纳哥",
  "defaultMessages.countries.MD": "摩尔多瓦",
  "defaultMessages.countries.ME": "黑山",
  "defaultMessages.countries.MG": "马达加斯加",
  "defaultMessages.countries.MH": "马绍尔群岛",
  "defaultMessages.countries.MK": "马其顿",
  "defaultMessages.countries.ML": "马里",
  "defaultMessages.countries.MM": "缅甸",
  "defaultMessages.countries.MN": "蒙古",
  "defaultMessages.countries.MO": "澳门",
  "defaultMessages.countries.MP": "北马里亚纳群岛",
  "defaultMessages.countries.MQ": "马提尼克（法属）",
  "defaultMessages.countries.MR": "毛里塔尼亚",
  "defaultMessages.countries.MS": "蒙特塞拉特",
  "defaultMessages.countries.MT": "马耳他",
  "defaultMessages.countries.MU": "毛里求斯",
  "defaultMessages.countries.MV": "马尔代夫",
  "defaultMessages.countries.MW": "马拉维",
  "defaultMessages.countries.MX": "墨西哥",
  "defaultMessages.countries.MY": "马来西亚",
  "defaultMessages.countries.MZ": "莫桑比克",
  "defaultMessages.countries.NA": "纳米比亚",
  "defaultMessages.countries.NC": "新喀里多尼亚（法属）",
  "defaultMessages.countries.NE": "尼日尔",
  "defaultMessages.countries.NF": "诺福克岛",
  "defaultMessages.countries.NG": "尼日利亚",
  "defaultMessages.countries.NI": "尼加拉瓜",
  "defaultMessages.countries.NL": "荷兰",
  "defaultMessages.countries.NO": "挪威",
  "defaultMessages.countries.NP": "尼泊尔",
  "defaultMessages.countries.NR": "瑙鲁",
  "defaultMessages.countries.NU": "纽埃",
  "defaultMessages.countries.NZ": "新西兰",
  "defaultMessages.countries.OM": "阿曼",
  "defaultMessages.countries.PA": "巴拿马",
  "defaultMessages.countries.PE": "秘鲁",
  "defaultMessages.countries.PF": "法属波利尼西亚",
  "defaultMessages.countries.PG": "巴布亚新几内亚",
  "defaultMessages.countries.PH": "菲律宾",
  "defaultMessages.countries.PK": "巴基斯坦",
  "defaultMessages.countries.PL": "波兰",
  "defaultMessages.countries.PM": "圣皮埃尔和密克隆",
  "defaultMessages.countries.PN": "皮特凯恩岛",
  "defaultMessages.countries.PR": "波多黎各",
  "defaultMessages.countries.PS": "巴勒斯坦",
  "defaultMessages.countries.PT": "葡萄牙",
  "defaultMessages.countries.PW": "帕劳",
  "defaultMessages.countries.PY": "巴拉圭",
  "defaultMessages.countries.QA": "卡塔尔",
  "defaultMessages.countries.RE": "留尼汪（法属）",
  "defaultMessages.countries.RO": "罗马尼亚",
  "defaultMessages.countries.RS": "塞尔维亚",
  "defaultMessages.countries.RU": "俄罗斯联邦",
  "defaultMessages.countries.RW": "卢旺达",
  "defaultMessages.countries.SA": "沙特阿拉伯",
  "defaultMessages.countries.SB": "所罗门群岛",
  "defaultMessages.countries.SC": "塞舌尔",
  "defaultMessages.countries.SD": "苏丹",
  "defaultMessages.countries.SE": "瑞典",
  "defaultMessages.countries.SG": "新加坡",
  "defaultMessages.countries.SH": "圣赫勒拿",
  "defaultMessages.countries.SI": "斯洛文尼亚",
  "defaultMessages.countries.SK": "斯洛伐克共和国",
  "defaultMessages.countries.SL": "塞拉利昂",
  "defaultMessages.countries.SM": "圣马力诺",
  "defaultMessages.countries.SN": "塞内加尔",
  "defaultMessages.countries.SO": "索马里",
  "defaultMessages.countries.SR": "苏里南",
  "defaultMessages.countries.SS": "南苏丹",
  "defaultMessages.countries.ST": "圣多美和普林西比",
  "defaultMessages.countries.SV": "萨尔瓦多",
  "defaultMessages.countries.SY": "叙利亚",
  "defaultMessages.countries.SZ": "斯威士兰",
  "defaultMessages.countries.TC": "特克斯和凯科斯群岛",
  "defaultMessages.countries.TD": "乍得",
  "defaultMessages.countries.TF": "法属南部领地",
  "defaultMessages.countries.TG": "多哥",
  "defaultMessages.countries.TH": "泰国",
  "defaultMessages.countries.TJ": "塔吉克斯坦",
  "defaultMessages.countries.TK": "托克劳",
  "defaultMessages.countries.TL": "东帝汶",
  "defaultMessages.countries.TM": "土库曼斯坦",
  "defaultMessages.countries.TN": "突尼斯",
  "defaultMessages.countries.TO": "汤加",
  "defaultMessages.countries.TR": "土耳其",
  "defaultMessages.countries.TT": "特立尼达和多巴哥",
  "defaultMessages.countries.TV": "图瓦卢",
  "defaultMessages.countries.TW": "台湾",
  "defaultMessages.countries.TZ": "坦桑尼亚",
  "defaultMessages.countries.UA": "乌克兰",
  "defaultMessages.countries.UG": "乌干达",
  "defaultMessages.countries.UM": "美国本土外小岛屿",
  "defaultMessages.countries.US": "美国",
  "defaultMessages.countries.UY": "乌拉圭",
  "defaultMessages.countries.UZ": "乌兹别克斯坦",
  "defaultMessages.countries.VA": "梵蒂冈城国",
  "defaultMessages.countries.VC": "圣文森特和格林纳丁斯",
  "defaultMessages.countries.VE": "委内瑞拉",
  "defaultMessages.countries.VG": "英属维尔京群岛",
  "defaultMessages.countries.VI": "美属维尔京群岛",
  "defaultMessages.countries.VN": "越南",
  "defaultMessages.countries.VU": "瓦努阿图",
  "defaultMessages.countries.WF": "瓦利斯和富图纳群岛",
  "defaultMessages.countries.WS": "萨摩亚",
  "defaultMessages.countries.XK": "科索沃",
  "defaultMessages.countries.YE": "也门",
  "defaultMessages.countries.YT": "马约特",
  "defaultMessages.countries.ZA": "南非",
  "defaultMessages.countries.ZM": "赞比亚",
  "defaultMessages.countries.ZW": "津巴布韦",
  "defaultMessages.country": "国家",
  "defaultMessages.countryPlaceholder": "国家",
  "defaultMessages.cvecNumber": "CVEC证书编号",
  "defaultMessages.cvecNumberExplanation": "可选 - 添加您的CVEC编号可提高即时验证的成功率。",
  "defaultMessages.dateTime.20_MIN": "20分钟",
  "defaultMessages.dateTime.24_HRS": "24小时",
  "defaultMessages.dateTime.2_DAY": "2天",
  "defaultMessages.dateTime.2_HRS": "2小时",
  "defaultMessages.dateTime.2_MIN": "2分钟",
  "defaultMessages.dateTime.3_DAY": "3天",
  "defaultMessages.dateTime.A_FEW_DAYS": "几天",
  "defaultMessages.dateTime.A_FEW_HOURS": "几小时",
  "defaultMessages.dateTime.A_FEW_MINUTES": "几分钟",
  "defaultMessages.dateTime.A_HALF_HOUR": "半小时",
  "defaultMessages.dateTime.april": "四月",
  "defaultMessages.dateTime.august": "八月",
  "defaultMessages.dateTime.day": "日",
  "defaultMessages.dateTime.december": "十二月",
  "defaultMessages.dateTime.february": "二月",
  "defaultMessages.dateTime.january": "一月",
  "defaultMessages.dateTime.july": "七月",
  "defaultMessages.dateTime.june": "六月",
  "defaultMessages.dateTime.march": "三月",
  "defaultMessages.dateTime.may": "五月",
  "defaultMessages.dateTime.month": "月",
  "defaultMessages.dateTime.november": "十一月",
  "defaultMessages.dateTime.october": "十月",
  "defaultMessages.dateTime.september": "九月",
  "defaultMessages.dateTime.year": "年",
  "defaultMessages.dischargeDate": "退役日期",
  "defaultMessages.driverLicenseNumber": "驾驶证号码",
  "defaultMessages.driverLicenseNumberPlaceholder": "驾驶证号码",
  "defaultMessages.driverLicenseState": "驾驶证发证州",
  "defaultMessages.ebtCardNumber": "EBT卡号",
  "defaultMessages.emailAddress": "电子邮件地址",
  "defaultMessages.emailAddressPlaceholder": "电子邮件地址",
  "defaultMessages.error": "我们无法继续您的验证",
  "defaultMessages.errorDetailId.govIdMismatch": "您的身份证件与您在表单中输入的信息不匹配。请重试。",
  "defaultMessages.errorDetailId.govIdOtherFailure": "验证您的身份证件时出现问题。<feedbackFormLink>请联系SheerID支持</feedbackFormLink>。",
  "defaultMessages.errorDetailId.govIdRetakeBiometric": "验证您的动态捕捉时出现问题。请重试：<selfieTipsLink/>。",
  "defaultMessages.errorDetailId.govIdRetakeId": "验证您的政府颁发身份证件时出现问题。请重试：<imageTipsLink/>。",
  "defaultMessages.errorDetailId.govIdUnsupportedDoc": "不支持此文件。请使用支持的政府颁发身份证件重试。",
  "defaultMessages.errorDetailId.personLimit": "您似乎已获得此优惠的批准。",
  "defaultMessages.errorDetailId.troubleVerifying": "我们在验证您的身份时遇到困难。<feedbackFormLink>请联系SheerID支持</feedbackFormLink>。",
  "defaultMessages.errorDetailId.unableToVerify": "目前无法验证您的身份。如果您认为这是错误，<feedbackFormLink>请联系SheerID支持</feedbackFormLink>。",
  "defaultMessages.errorDetailId.vpnsNotAllowed": "此计划不允许使用VPN。请关闭VPN后重试。如果您认为这是错误，<feedbackFormLink>请联系SheerID支持</feedbackFormLink>。",
  "defaultMessages.errorId.activeDutyStartDateBeforeBirthDate": "开始日期必须晚于出生日期",
  "defaultMessages.errorId.apiRateLimitExceeded": "当前无法处理您的请求，请稍后重试",
  "defaultMessages.errorId.dischargeDateBeforeBirthDate": "退役日期早于出生日期",
  "defaultMessages.errorId.docReviewLimitExceeded": "感谢您上传文件。我们无法通过所提供的文件确认您的身份状态。",
  "defaultMessages.errorId.duplicateFile": "部分文件似乎相同，请选择其他文件。",
  "defaultMessages.errorId.expiredEmailLoopToken": "很抱歉，找不到您请求的页面。URL可能不正确，或页面已不再可用。",
  "defaultMessages.errorId.expiredProgram": "由于需求量极大，该优惠已不再提供。请明天再查看是否可用。",
  "defaultMessages.errorId.expiredSMSCode": "验证码已过期",
  "defaultMessages.errorId.expiredVerification": "此验证已过期。请提交新的验证。",
  "defaultMessages.errorId.failedToFetch": "HTTP请求失败",
  "defaultMessages.errorId.fraudRulesReject": "请检查您的信息是否正确，以及您并未使用 VPN 或其他隐私软件。",
  "defaultMessages.errorId.futureActiveDutyStartDate": "开始日期为未来日期",
  "defaultMessages.errorId.futureBirthDate": "出生日期为未来日期",
  "defaultMessages.errorId.futureDischargeDate": "退役日期为未来日期",
  "defaultMessages.errorId.inactiveProgram": "由于需求量极大，该优惠已不再提供。请明天再查看是否可用。",
  "defaultMessages.errorId.incorrectVerificationOverrideCodeAttemptLimitExceeded": "覆盖码尝试次数已超限",
  "defaultMessages.errorId.ineligibleOrganization": "您选择的机构不符合此优惠的条件。",
  "defaultMessages.errorId.internalServerError": "内部服务器错误",
  "defaultMessages.errorId.invalidActiveDutyStartDate": "无效的开始日期",
  "defaultMessages.errorId.invalidAddress": "无效的地址",
  "defaultMessages.errorId.invalidApiToken": "提供的API令牌无效或为空",
  "defaultMessages.errorId.invalidAuthenticationLoopToken": "提供的代码无效",
  "defaultMessages.errorId.invalidBirthDate": "无效的出生日期",
  "defaultMessages.errorId.invalidCaptchaToken": "验证码验证失败。",
  "defaultMessages.errorId.invalidCity": "无效的城市",
  "defaultMessages.errorId.invalidCountry": "无效的国家",
  "defaultMessages.errorId.invalidCvecNumber": "无效的CVEC证书编号",
  "defaultMessages.errorId.invalidDischargeDate": "无效的退役日期",
  "defaultMessages.errorId.invalidDocUploadToken": "提供的文件上传令牌无效",
  "defaultMessages.errorId.invalidDriverLicenseNumber": "无效的驾驶证号码",
  "defaultMessages.errorId.invalidEbtCardNumber": "无效的EBT卡号",
  "defaultMessages.errorId.invalidEmail": "无效的电子邮件",
  "defaultMessages.errorId.invalidEmailLoopToken": "很抱歉，找不到您请求的页面。URL可能不正确，或页面已不再可用。",
  "defaultMessages.errorId.invalidFileSizeEmpty": "一个或多个文件为空",
  "defaultMessages.errorId.invalidFileSizeMax": "一个或多个文件过大（最大：10MB）",
  "defaultMessages.errorId.invalidFirstName": "无效的名字",
  "defaultMessages.errorId.invalidFirstResponderStatus": "无效的急救人员状态",
  "defaultMessages.errorId.invalidLastName": "无效的姓氏",
  "defaultMessages.errorId.invalidMemberId": "无效的ID编号",
  "defaultMessages.errorId.invalidMilitaryStatus": "无效的军人身份",
  "defaultMessages.errorId.invalidNumberOfFiles": "文件数量超过上限（最大：5个）",
  "defaultMessages.errorId.invalidOptIn": "必须选中才能继续",
  "defaultMessages.errorId.invalidOrganization": "您必须从列表中选择一个机构",
  "defaultMessages.errorId.invalidOverrideCode": "无效的覆盖码",
  "defaultMessages.errorId.invalidPhoneNumber": "无效的手机号码",
  "defaultMessages.errorId.invalidPostalCode": "无效的邮政编码",
  "defaultMessages.errorId.invalidProgram": "无效的计划",
  "defaultMessages.errorId.invalidRequest": "无效的请求",
  "defaultMessages.errorId.invalidSMSCode": "无法验证验证码",
  "defaultMessages.errorId.invalidSocialSecurityNumber": "无效的社会安全号码",
  "defaultMessages.errorId.invalidState": "无效的州",
  "defaultMessages.errorId.invalidStatus": "无效的状态",
  "defaultMessages.errorId.invalidStatuses": "无效的状态",
  "defaultMessages.errorId.invalidStep": "无效的步骤",
  "defaultMessages.errorId.marketConsentRequired": "需要市场营销同意",
  "defaultMessages.errorId.maxMetadataLengthExceeded": "元数据值的最大长度已超限",
  "defaultMessages.errorId.maxMetadataValuesExceeded": "元数据值的最大数量已超限",
  "defaultMessages.errorId.missingRequiredExternalId": "您必须登录才能验证。请登录您的账户后再试。",
  "defaultMessages.errorId.missingRequiredMetadata": "您必须登录才能验证。请登录您的账户后再试。",
  "defaultMessages.errorId.noProgram": "未找到计划",
  "defaultMessages.errorId.noRemainingRewardCodes": "由于需求量极大，该优惠已不再提供。请明天再查看是否可用。",
  "defaultMessages.errorId.noValidFiles": "没有有效文件",
  "defaultMessages.errorId.noVerification": "未找到验证",
  "defaultMessages.errorId.notApproved": "未获批准",
  "defaultMessages.errorId.notFound": "未找到",
  "defaultMessages.errorId.outsideAgePerson": "出生日期不符合此优惠的条件。",
  "defaultMessages.errorId.requestTimeout": "请求超时",
  "defaultMessages.errorId.simulatedError": "这是一个模拟错误",
  "defaultMessages.errorId.unauthorizedAccountStatus": "此优惠已暂时停止。请联系品牌的客户支持以获取更多信息。",
  "defaultMessages.errorId.unauthorizedDomain": "未授权的域名",
  "defaultMessages.errorId.underagePerson": "16岁以下人士不符合此优惠的条件。",
  "defaultMessages.errorId.unknownError": "未知错误",
  "defaultMessages.errorId.unsupportedDocMimeType": "一个或多个文件的格式不受支持",
  "defaultMessages.errorId.verificationLimitExceeded": "此优惠可能已被使用或尝试使用。",
  "defaultMessages.experiment.step.docUpload.documentConsiderations": "文件注意事项",
  "defaultMessages.firstName": "名字",
  "defaultMessages.firstNamePlaceholder": "名字",
  "defaultMessages.firstResponderInfoShared": "此处输入的信息将用于验证目的。",
  "defaultMessages.footerText": "提交以上个人信息，即表示我确认我的个人信息正在根据我申请折扣的商家的<privacyPolicy>隐私政策</privacyPolicy>进行收集，并且我了解我的个人信息将作为处理方/第三方服务提供商与SheerID共享，以便SheerID确认我是否有资格享受特别优惠。<aboutSheerID>了解更多关于SheerID的信息。</aboutSheerID>",
  "defaultMessages.footerText_sso": "继续操作，即表示您同意将您的个人信息与 SheerID 共享，SheerID 作为您所寻求折扣的商家的处理者/第三方服务提供商。您确认，为验证您的身份而收集的个人信息，将根据您所寻求折扣的商家的隐私政策进行处理。<aboutSheerID>了解更多关于 SheerID 的信息。</aboutSheerID>",
  "defaultMessages.getHelp": "获取帮助",
  "defaultMessages.graduationStatus": "毕业状态",
  "defaultMessages.howDoesReviewWork": "审核是如何进行的？",
  "defaultMessages.howDoesVerifyingWork": "验证是如何进行的？",
  "defaultMessages.infoShared1": "点击即表示我同意按照{privacyPolicyLink}中的描述，为验证我的资格目的处理我的信息",
  "defaultMessages.infoShared2": "。我了解我的信息将与{companyName}共享。",
  "defaultMessages.informationTransferredToUS": "您的信息将被传输至美国，并将根据SheerID的隐私政策进行处理。",
  "defaultMessages.instant": "即时",
  "defaultMessages.lastName": "姓氏",
  "defaultMessages.lastNamePlaceholder": "姓氏",
  "defaultMessages.limitExceededError": "我们无法继续此验证",
  "defaultMessages.loading": "加载中...",
  "defaultMessages.locales.ar": "العربية",
  "defaultMessages.locales.bg": "български",
  "defaultMessages.locales.bn-IN": "বাংলা (ভারত)",
  "defaultMessages.locales.cs": "čeština",
  "defaultMessages.locales.da": "Dansk",
  "defaultMessages.locales.de": "Deutsch",
  "defaultMessages.locales.el": "Ελληνικά",
  "defaultMessages.locales.en-GB": "English (UK)",
  "defaultMessages.locales.en-US": "English",
  "defaultMessages.locales.es": "Español",
  "defaultMessages.locales.es-ES": "Español (España)",
  "defaultMessages.locales.et": "eesti",
  "defaultMessages.locales.fa": "فارسی",
  "defaultMessages.locales.fi": "suomi",
  "defaultMessages.locales.fr": "Français",
  "defaultMessages.locales.fr-CA": "Français (Canada)",
  "defaultMessages.locales.ga": "Gaeilge",
  "defaultMessages.locales.hi-IN": "हिंदी (भारत)",
  "defaultMessages.locales.hr": "hrvatski",
  "defaultMessages.locales.hu": "magyar",
  "defaultMessages.locales.id": "Bahasa Indonesia",
  "defaultMessages.locales.is": "Íslenska",
  "defaultMessages.locales.it": "Italiano",
  "defaultMessages.locales.iw": "עברית",
  "defaultMessages.locales.ja": "日本語",
  "defaultMessages.locales.kk": "Қазақ",
  "defaultMessages.locales.ko": "한국어",
  "defaultMessages.locales.lo": "ລາວ",
  "defaultMessages.locales.lt": "Lietuvių",
  "defaultMessages.locales.lv": "Latviešu",
  "defaultMessages.locales.ms": "Bahasa Melayu",
  "defaultMessages.locales.nl": "Nederlands",
  "defaultMessages.locales.nl-BE": "Vlaams",
  "defaultMessages.locales.no": "Norsk",
  "defaultMessages.locales.pl": "Polski",
  "defaultMessages.locales.pt": "Português",
  "defaultMessages.locales.pt-BR": "Português (Brasil)",
  "defaultMessages.locales.ro": "Română",
  "defaultMessages.locales.ru": "Русский",
  "defaultMessages.locales.sk": "slovenský",
  "defaultMessages.locales.sl": "Slovenščina",
  "defaultMessages.locales.sr": "Српски",
  "defaultMessages.locales.sv": "Svenska",
  "defaultMessages.locales.sw": "Kiswahili",
  "defaultMessages.locales.ta": "தமிழ்",
  "defaultMessages.locales.th": "ไทย",
  "defaultMessages.locales.tl": "Filipino",
  "defaultMessages.locales.tr": "Türkçe",
  "defaultMessages.locales.uk": "Українська",
  "defaultMessages.locales.ur": "اردو",
  "defaultMessages.locales.vi": "Tiếng Việt",
  "defaultMessages.locales.zh": "中文（繁体）",
  "defaultMessages.locales.zh-HK": "中文（香港）",
  "defaultMessages.locales.zu": "IsiZulu",
  "defaultMessages.lowIncomeOrganization": "政府援助计划",
  "defaultMessages.lowIncomeOrganizationPlaceholder": "政府援助计划",
  "defaultMessages.lowRewardPool": "&#128293; 仅剩 {offersRemaining} 个优惠！",
  "defaultMessages.memberId": "ID号码",
  "defaultMessages.memberIdPlaceholder": "ID号码",
  "defaultMessages.militaryFamilyCardNote": "注意：此优惠仅适用于持有家属ID卡的军人家庭成员。",
  "defaultMessages.militaryInfoShared": "此处输入的信息将用于验证目的。",
  "defaultMessages.militaryStatus": "军人身份",
  "defaultMessages.multipleLocationsTips": "如果您的学术机构有多个校区，但您没有看到您所在的校区，请输入主要校区。",
  "defaultMessages.noOptions": "无选项",
  "defaultMessages.openMenu": "打开菜单",
  "defaultMessages.optIn": "是的，请向我发送 {company} 的营销通讯，包括独家促销、特别优惠、最新产品等",
  "defaultMessages.optional": "可选",
  "defaultMessages.orgSearchSortAccessibilityLabel": "对搜索结果排序",
  "defaultMessages.orgSearchSortByDistance": "按距离排序",
  "defaultMessages.orgSearchSortByRelevance": "按相关性排序",
  "defaultMessages.organization": "组织",
  "defaultMessages.organizationPlaceholder": "组织",
  "defaultMessages.personalInformation": "个人信息",
  "defaultMessages.personalOrSchoolIsFine": "个人或学校电子邮件均可",
  "defaultMessages.phoneNumber": "手机号码",
  "defaultMessages.phoneNumberExplanation": "可选 - 获取状态更新的短信通知",
  "defaultMessages.phoneNumberWarnMessage1": "提交含手机号码的表单即表示您同意接收用于验证目的的短信。可能适用标准运营商短信及数据费率。",
  "defaultMessages.phoneNumberWarnMessage2": "您授权您的移动服务提供商向 SheerID 披露您的手机号码及某些账户信息，仅用于身份验证和防止欺诈。",
  "defaultMessages.phoneUsPlaceholder": "555-555-5555",
  "defaultMessages.postalCode": "邮政编码",
  "defaultMessages.postalCodeExplanation": "请使用您执照颁发机构存档的地址",
  "defaultMessages.postalCodePlaceholder": "邮政编码",
  "defaultMessages.poweredBy": "验证服务由 SheerID 提供",
  "defaultMessages.privacyPolicy": "隐私政策",
  "defaultMessages.proceed": "继续",
  "defaultMessages.requestSchool": "找不到您的学校？申请将其添加。",
  "defaultMessages.requiredFields": "* 必填信息",
  "defaultMessages.rewardCodeEmailNotification": "我们已将副本发送至您的电子邮件，您可以立即或稍后使用您的新代码。请留意来自 verify@sheerid.com 的电子邮件。",
  "defaultMessages.school": "学校",
  "defaultMessages.schoolName": "学校",
  "defaultMessages.schoolNamePlaceholder": "学校",
  "defaultMessages.sheeridFaqs": "SheerID 常见问题解答",
  "defaultMessages.smsCodePlaceholder": "短信验证码",
  "defaultMessages.ssn": "社会安全号码",
  "defaultMessages.ssnPlaceholder": "000-00-0000",
  "defaultMessages.state": "州",
  "defaultMessages.statePlaceholder": "州",
  "defaultMessages.states.AK": "阿拉斯加州",
  "defaultMessages.states.AL": "阿拉巴马州",
  "defaultMessages.states.AR": "阿肯色州",
  "defaultMessages.states.AS": "美属萨摩亚",
  "defaultMessages.states.AZ": "亚利桑那州",
  "defaultMessages.states.CA": "加利福尼亚州",
  "defaultMessages.states.CO": "科罗拉多州",
  "defaultMessages.states.CT": "康涅狄格州",
  "defaultMessages.states.DC": "哥伦比亚特区",
  "defaultMessages.states.DE": "特拉华州",
  "defaultMessages.states.FL": "佛罗里达州",
  "defaultMessages.states.GA": "乔治亚州",
  "defaultMessages.states.GU": "关岛",
  "defaultMessages.states.HI": "夏威夷州",
  "defaultMessages.states.IA": "爱荷华州",
  "defaultMessages.states.ID": "爱达荷州",
  "defaultMessages.states.IL": "伊利诺伊州",
  "defaultMessages.states.IN": "印第安纳州",
  "defaultMessages.states.KS": "堪萨斯州",
  "defaultMessages.states.KY": "肯塔基州",
  "defaultMessages.states.LA": "路易斯安那州",
  "defaultMessages.states.MA": "马萨诸塞州",
  "defaultMessages.states.MD": "马里兰州",
  "defaultMessages.states.ME": "缅因州",
  "defaultMessages.states.MI": "密歇根州",
  "defaultMessages.states.MN": "明尼苏达州",
  "defaultMessages.states.MO": "密苏里州",
  "defaultMessages.states.MS": "密西西比州",
  "defaultMessages.states.MT": "蒙大拿州",
  "defaultMessages.states.NC": "北卡罗来纳州",
  "defaultMessages.states.ND": "北达科他州",
  "defaultMessages.states.NE": "内布拉斯加州",
  "defaultMessages.states.NH": "新罕布什尔州",
  "defaultMessages.states.NJ": "新泽西州",
  "defaultMessages.states.NM": "新墨西哥州",
  "defaultMessages.states.NV": "内华达州",
  "defaultMessages.states.NY": "纽约州",
  "defaultMessages.states.OH": "俄亥俄州",
  "defaultMessages.states.OK": "俄克拉荷马州",
  "defaultMessages.states.OR": "俄勒冈州",
  "defaultMessages.states.PA": "宾夕法尼亚州",
  "defaultMessages.states.PR": "波多黎各",
  "defaultMessages.states.RI": "罗得岛州",
  "defaultMessages.states.SC": "南卡罗来纳州",
  "defaultMessages.states.SD": "南达科他州",
  "defaultMessages.states.TN": "田纳西州",
  "defaultMessages.states.TX": "德克萨斯州",
  "defaultMessages.states.UT": "犹他州",
  "defaultMessages.states.VA": "弗吉尼亚州",
  "defaultMessages.states.VI": "美属维尔京群岛",
  "defaultMessages.states.VT": "佛蒙特州",
  "defaultMessages.states.WA": "华盛顿州",
  "defaultMessages.states.WI": "威斯康星州",
  "defaultMessages.states.WV": "西弗吉尼亚州",
  "defaultMessages.states.WY": "怀俄明州",
  "defaultMessages.status": "状态",
  "defaultMessages.statusPlaceholder": "状态",
  "defaultMessages.step.collectIdentifier.inputExplanation": "用于发送验证码",
  "defaultMessages.step.collectIdentifier.submitButton": "继续",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdExplanation": "您的专业会员注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdLabel": "注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerExplanation": "您的专业会员注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerLabel": "注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberExplanation": "您的专业会员注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberLabel": "全球位置编号",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoExplanation": "您的专业会员注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoLabel": "注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberExplanation": "您的专业会员注册号",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberLabel": "注册号",
  "defaultMessages.step.collectPersonalInfo.submitButton": "验证我的 {segment} 状态",
  "defaultMessages.step.collectSocialSecurityNumber.selectOption": "选择一个选项",
  "defaultMessages.step.collectSocialSecurityNumber.title": "输入您的社会安全号码",
  "defaultMessages.step.collectSocialSecurityNumber.uploadDoc": "上传文件",
  "defaultMessages.step.collectSocialSecurityNumber.uploadInstead": "改为上传文件",
  "defaultMessages.step.collectSocialSecurityNumber.useSsn": "使用您的社会安全号码进行验证",
  "defaultMessages.step.completeAuthentication.manuallyVerifyButton": "手动验证",
  "defaultMessages.step.completeAuthentication.subtitle": "输入发送至您邮箱的验证码。",
  "defaultMessages.step.completeAuthentication.title": "使用「记住我」验证",
  "defaultMessages.step.consolation.subtitle": "虽然我们未能验证您的身份，但 {companyName} 仍为您提供此代码。此代码为您专属，且只能使用一次。",
  "defaultMessages.step.consolation.title": "领取您的优惠",
  "defaultMessages.step.consolation.verificationOnly": "如对此优惠有任何疑问，请联系 {companyName}。",
  "defaultMessages.step.docUpload.acceptableUploadExamples": "可接受的示例包括：",
  "defaultMessages.step.docUpload.acceptableUploads.age.birthCertificate": "出生证明",
  "defaultMessages.step.docUpload.acceptableUploads.age.driversLicense": "驾驶证",
  "defaultMessages.step.docUpload.acceptableUploads.age.passport": "护照",
  "defaultMessages.step.docUpload.acceptableUploads.age.stateId": "州政府颁发的身份证",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdContent": "根据联邦法律，SheerID 不接受提交现役/预备役军人身份证。",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdTitle": "请勿上传您的军人身份证照片。",
  "defaultMessages.step.docUpload.acceptableUploads.employment.employeeIdCard": "员工身份证",
  "defaultMessages.step.docUpload.acceptableUploads.employment.officialLetter": "一封官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.employment.payStub": "最近90天内的薪资单",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.idCard": "身份证",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.letter": "官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.payStub": "最近60天内的薪资存根",
  "defaultMessages.step.docUpload.acceptableUploads.licensedProfessional.license": "执照证书",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.program": "显示您有资格获得所选政府援助计划的卡片正反面。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalLetter": "由政府机构发出的所选政府援助计划的批准函（例如，补充保障收入 (SSI) 资格函）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalScreenshot": "所选政府援助计划在线门户的截图，显示您有资格获得该计划（您在线账户上的 Medicaid 申请状态截图）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programBankStatement": "显示所选福利最近付款的银行对账单。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programCard": "显示您有资格获得所选政府援助计划的卡片正反面（例如，SNAP 计划的 EBT 卡）。",
  "defaultMessages.step.docUpload.acceptableUploads.medical.idCard": "身份徽章",
  "defaultMessages.step.docUpload.acceptableUploads.medical.letterEmployment": "在过去90天内带有公司信头的就业证明信",
  "defaultMessages.step.docUpload.acceptableUploads.medical.licenseCertificate": "医疗执照或证书",
  "defaultMessages.step.docUpload.acceptableUploads.medical.payStub": "最近90天内的薪资存根",
  "defaultMessages.step.docUpload.acceptableUploads.medical.photoPayStub": "附照片的身份证明和近期薪资存根",
  "defaultMessages.step.docUpload.acceptableUploads.member.idCard": "会员文件",
  "defaultMessages.step.docUpload.acceptableUploads.member.payStub": "最近90天内的薪资存根",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.leaveEarningStatement": "假期和收入报表（在过去90天内注明日期）",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.uniformedServicesId": "制服服务身份证",
  "defaultMessages.step.docUpload.acceptableUploads.military.activeDuty": "任何能证明您目前在武装部队服现役满30天或以上的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.dependent": "任何您在法律上可以提供的文件，以证明您是已登记的军人家属。",
  "defaultMessages.step.docUpload.acceptableUploads.military.goldStarFamily": "DD1300表格/伤亡报告，显示申请人为已故者的家庭成员",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.blueUniformedId": "显示退役状态的制服服务身份证",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.dd214Form": "DD214 <em>(如果您服役20年以上或残疾评定达30%或以上)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.retireeId": "退役人员身份证",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaDigitalId": "VA Digital ID <em>(如果您服役20年以上或残疾评定达30%或以上)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaHealthBenefitsCard": "VA健康福利函（如果您的残疾评定达30%或以上）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.leaveEarningStatement": "假期和收入报表（在过去90天内注明日期）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.uniformedServicesId": "制服服务身份证",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservistA": "任何显示您目前在武装部队后备役部门服役的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.retiree": "任何能证明您是武装部队退役人员的文件",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dd214Form": "DD214表格",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.departmentVeteranId": "退伍军人事务部身份证",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dischargeCertificate": "退役证书",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.driverLicenseVeteran": "附退伍军人标志的驾驶证",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaDigitalId": "VA 数字身份",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaHealthBenefitsCard": "VA健康福利卡",
  "defaultMessages.step.docUpload.acceptableUploads.military.veteran": "任何能证明您达到军事服役资格并光荣退伍的文件",
  "defaultMessages.step.docUpload.acceptableUploads.officialLetter": "官方信函",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.changeOfAddress": "美国邮政服务地址变更确认函",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.mortgageDeed": "抵押契约",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.rentalAgreement": "租约或租赁协议",
  "defaultMessages.step.docUpload.acceptableUploads.senior.birthCertificate": "出生证明",
  "defaultMessages.step.docUpload.acceptableUploads.senior.driversLicense": "驾驶证",
  "defaultMessages.step.docUpload.acceptableUploads.senior.passport": "护照",
  "defaultMessages.step.docUpload.acceptableUploads.senior.stateId": "州政府颁发的身份证",
  "defaultMessages.step.docUpload.acceptableUploads.student.classSchedule": "课程表",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.alumniCard": "校友／校友会会员卡",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.diploma": "您的毕业证书副本",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.letterOfCompletion": "教务处出具的完成证明信",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.transcript": "正式或非正式成绩单",
  "defaultMessages.step.docUpload.acceptableUploads.student.idCard": "附到期日期的学生身份证",
  "defaultMessages.step.docUpload.acceptableUploads.student.tuitionReceipt": "学费收据",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.idCard": "教育者身份证",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.payStub": "最近90天内的薪资存根",
  "defaultMessages.step.docUpload.acceptedTypes": "文件必须为 .jpg .jpeg .png .pdf",
  "defaultMessages.step.docUpload.addFile": "添加文件",
  "defaultMessages.step.docUpload.allowedDocuments": "请只上传您依法获准提供的文件。",
  "defaultMessages.step.docUpload.canIFinishLater": "我可以稍后完成吗？",
  "defaultMessages.step.docUpload.canIFinishLaterDetails": "是的，如果您现在未完成，我们将自动向您提供的电子邮件地址发送一封邮件，附有返回此步骤的链接。",
  "defaultMessages.step.docUpload.documentReviewProcess": "文件将通过人工和自动文件审核的优化组合进行真实性审查，并与您提供的信息进行比对。",
  "defaultMessages.step.docUpload.documentsMustInclude": "您的文件或文件组合必须包含：",
  "defaultMessages.step.docUpload.nameChanged": "如果您的姓名在文件签发后发生了更改，请上传第二份显示您正式姓名更改的文件。",
  "defaultMessages.step.docUpload.rejectedNextStep": "请更正并重试。",
  "defaultMessages.step.docUpload.rejectedSubtitle": "由于以下原因，我们无法确认您的资格：",
  "defaultMessages.step.docUpload.rejectionReasons.CUSTOM_VALUE_OTHER": "提交的文件缺少确立此优惠资格所需的要求。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_DATE_OTHER": "提交的文件不符合确立此优惠资格的日期要求。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EMAIL_SCREENSHOT": "我们无法接受电子邮件的截图。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EXPIRED": "该文件已过期或签发时间过早。请上传较新的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_HANDWRITTEN": "我们无法接受手写文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_LIKELY_FRAUD": "该文件不足以确立此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED": "您提交的文件缺少签发日期或签发时间过早。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED_FACULTY": "您提交的文件无法证明您在本学年度任职。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_PASSWORD_PROTECTED": "我们无法接受受密码保护的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_STATUS_OTHER": "提交的文件显示的状态不足以确立此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_TOO_FUTURE": "文件中显示的日期距离未来太远。请上传较新的文件以证明您的当前状态。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNREADABLE": "由于图像质量差，文件无法读取。请确保您有清晰可读、明亮清晰的图像，并再次尝试提交。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNSUPPORTED": "该文件不是官方文件或不在接受的文件类型列表中。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_VALID_OTHER": "提交的文件无法确立此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.EBT_CARD_NUMBER_OTHER": "提交的 EBT 卡无法确立此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_JOB_TITLE": "文件中显示的职位名称不符合此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_ORGANIZATION": "您提交的文件上的机构不符合此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "高中生不符合此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_CUSTOM_VALUE": "文件缺少确立您获得此优惠资格所需的信息。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_DOCUMENT_DATE": "文件中显示的日期不足以证明您的当前状态。请上传包含近期月份和年份的文件。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_EBT_CARD_NUMBER": "上传的 EBT 卡不足以确立此优惠的资格。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_STATUS": "该文件无法证明您具有符合此优惠资格的状态。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_BIRTHDATE": "文件上的出生日期与您在验证表格中输入的出生日期不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_COMPANY_NAME_OR_ADDRESS": "您文件中的公司名称或地址与您在验证表格中输入的内容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_CUSTOM_VALUE": "文件中显示的某些信息与您在验证表格中输入的内容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_EBT_CARD_NUMBER": "上传的EBT卡号与验证表格中输入的号码不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION": "您提交的文件上的机构名称与您在验证表格中列出的机构不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_COUNTRY": "验证表格上选择的国家/地区与提交文件上显示的国家/地区不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_NAME": "在验证表格中输入的机构名称与提交文件中显示的机构名称不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_FIRST_NAME": "文件上的名字与您在验证表格中输入的名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_LAST_NAME": "在验证表格中输入的姓氏与提交文件上显示的姓名不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_NAME": "您提交的文件上的信息与验证表格上提交的姓名和/或名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_STATUS": "文件上的状态与您在验证表格中输入的状态不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_CUSTOM_VALUE": "文件缺少确立您此优惠资格所需的信息。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_DOCUMENT_DATE": "缺少当前日期。请上传证明您当前状态的官方有日期文件。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_EBT_CARD_NUMBER": "上传的EBT卡缺少卡号。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION": "您提交的文件未提供确定此优惠资格所需的所有信息。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "您提交的文件未显示与美国武装部队合格分支的关联。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_BIRTHDATE": "您的出生日期缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_ORGANIZATION_NAME": "在验证表格中输入的机构名称在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_PERSON_NAME": "您提交的文件缺少名字和/或姓氏。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "您提交的文件无法证明您在本学期的入学情况。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_OR_MISMATCH_JOB_TITLE": "您提交的文件上的职称缺失或与您在验证表格中输入的内容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_FIRST_NAME": "您的名字在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_LAST_NAME": "您的姓氏在提交的文件中缺失。",
  "defaultMessages.step.docUpload.rejectionReasons.ORGANIZATION_NAME_OTHER": "提交文件中显示的机构名称与验证表格中提供的机构名称不同。",
  "defaultMessages.step.docUpload.rejectionReasons.OTHER_CONTACT_US": "我们在验证您的优惠资格时遇到问题。请联系SheerID客户服务寻求帮助：customerservice@sheerid.com",
  "defaultMessages.step.docUpload.rejectionReasons.OUT_OF_RANGE_BIRTHDATE": "您的出生日期超出此优惠的可接受范围。",
  "defaultMessages.step.docUpload.rejectionReasons.PAYSTUB_OUTDATED_LAST_30_DAYS": "请上传在过去30天内签发的工资单。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_BIRTHDATE_OTHER": "提交文件中显示的出生日期与验证表格中提供的出生日期不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIELD_MISMATCH": "提供文件中的某个字段与验证表格中提供的内容不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIRST_NAME_OTHER": "提交文件中显示的名字与验证表格中提供的名字不符。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_LAST_NAME_OTHER": "提交文件中显示的姓氏与验证表格中提供的姓氏不符。",
  "defaultMessages.step.docUpload.rejectionReasons.RESTRICTED_DOCUMENT": "由于法律限制，我们无法审查上传的政府颁发身份证件。",
  "defaultMessages.step.docUpload.reviewTime": "预计审核时间为 {{estimatedReviewTime}}。",
  "defaultMessages.step.docUpload.submitButtonLabel": "提交",
  "defaultMessages.step.docUpload.suggestedDocumentTypes": "建议的文件类型",
  "defaultMessages.step.docUpload.title": "如要继续，请上传确认您身份的文件",
  "defaultMessages.step.docUpload.uploadInfo.affiliation": "与该组织的<strong>当前隶属关系</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.birthDate": "<strong>出生日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.consentDE": "我同意为年龄验证目的处理和存储我的身份证副本。我理解该图像将自动保存为副本，并且我有权在上传前将序列号涂黑。",
  "defaultMessages.step.docUpload.uploadInfo.dateCurrentYear": "当前的学年或当前的学期日期",
  "defaultMessages.step.docUpload.uploadInfo.employment.company": "<strong>您的公司</strong>",
  "defaultMessages.step.docUpload.uploadInfo.employment.currentAffiliation": "与该公司的<strong>当前隶属关系</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.currentAffiliation": "您与该组织的当前隶属关系",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.emt.status": "在该组织中的当前<strong>EMT状态</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.firefighter.status": "在该组织中的当前<strong>消防员状态</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.license": "您作为急救人员的身份或执照",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.organization": "<strong>组织</strong>名称",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.police.status": "在该组织中的当前<strong>警察状态</strong>",
  "defaultMessages.step.docUpload.uploadInfo.fullName": "您在此表格中填写的<strong>全名</strong>",
  "defaultMessages.step.docUpload.uploadInfo.identity.validDate": "目前有效的日期",
  "defaultMessages.step.docUpload.uploadInfo.institutionName": "完整或缩写的<strong>学术机构名称</strong>或标志",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.licenseStatus": "<strong>专业执照及/或认证状态</strong>",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.validDate": "目前<strong>有效的日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.ebtNumber": "EBT卡号码",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.fullName": "您的全名",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.validDate": "<strong>有效的</strong>签发日期（最近12个月内）或有效期限（必须有效）",
  "defaultMessages.step.docUpload.uploadInfo.medical.medicalRole": "您作为<strong>医疗专业人员</strong>的角色",
  "defaultMessages.step.docUpload.uploadInfo.medical.status": "您的医疗专业人员身份",
  "defaultMessages.step.docUpload.uploadInfo.medical.validDate": "目前有效的<strong>日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.activeDuty.status": "目前<strong>现役</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.military.currentAffiliation": "您与武装部队的当前隶属关系",
  "defaultMessages.step.docUpload.uploadInfo.military.dischargeDate": "您的退役日期（如适用）",
  "defaultMessages.step.docUpload.uploadInfo.military.goldStarFamily.status": "目前<strong>军人家属</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryFamily.status": "目前<strong>军人家属</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryRetiree.status": "<strong>退休人员</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.military.reservist.status": "目前<strong>后备役</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.military.serviceBranch": "<strong>服役军种</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsDependent": "请上传能清楚显示您的名字、姓氏、有效日期及身份的文件",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdContent": "根据法律，SheerID无法处理军人身份证副本。",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdTitle": "请勿上传您的军人身份证照片。",
  "defaultMessages.step.docUpload.uploadInfo.military.veteran.status": "<strong>退伍军人</strong>状态",
  "defaultMessages.step.docUpload.uploadInfo.organization": "<strong>组织名称</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.address": "<strong>新地址</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.validDate": "您最近搬迁的<strong>有效日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.senior.birthDate": "<strong>出生日期</strong>",
  "defaultMessages.step.docUpload.uploadInfo.student.enrollmentDate": "证明当前学期入学的日期（或最近3个月内）",
  "defaultMessages.step.docUpload.uploadInfo.student.graduate.degreeConferral": "<strong>学位授予证明</strong>（例如“已授予学位”状态或毕业日期）",
  "defaultMessages.step.docUpload.uploadInfo.student.school": "您的学校",
  "defaultMessages.step.docUpload.uploadInfo.teacher.currentSchoolYear": "当前学年的日期",
  "defaultMessages.step.docUpload.uploadInfo.teacher.school": "您的学校",
  "defaultMessages.step.docUpload.whatHappensNext": "接下来会发生什么？",
  "defaultMessages.step.docUpload.whoIsSheerId": "文件审核由SheerID负责，SheerID是专门验证身份的可靠合作伙伴。",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.alternative": "无法访问工作电子邮件地址？",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.label": "工作电子邮件地址",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.send": "发送电子邮件",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.subtitle": "输入您的雇主提供的电子邮件地址，我们将向您发送一个验证链接",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.title": "使用您的工作电子邮件地址进行验证",
  "defaultMessages.step.emailLoop.errors.invalidEmail": "此电子邮件地址不适用于即时验证。请使用您的雇主提供的电子邮件地址，或在下方上传文档。",
  "defaultMessages.step.emailLoop.errors.resend": "发送电子邮件时出错",
  "defaultMessages.step.emailLoop.resendButton": "重新发送电子邮件",
  "defaultMessages.step.emailLoop.skipEmail": "找不到电子邮件？请检查您的垃圾邮件文件夹，或",
  "defaultMessages.step.emailLoop.skipEmail2": "电子邮件",
  "defaultMessages.step.emailLoop.skipEmailCTA": "重新发送",
  "defaultMessages.step.emailLoop.subtitle2": "打开 SheerID 从 (verify@sheerid.com) 发送的电子邮件，并选择链接以继续。这有助于确认您可以访问该电子邮件账户。",
  "defaultMessages.step.emailLoop.subtitleWithEmail": "我们已将个性化链接发送至 {email}，以继续验证流程。",
  "defaultMessages.step.emailLoop.subtitleWithoutEmail": "我们已将个性化链接发送至您的电子邮件，以继续验证流程。",
  "defaultMessages.step.emailLoop.successResend": "电子邮件已成功重新发送。",
  "defaultMessages.step.emailLoop.title": "查看您的电子邮件",
  "defaultMessages.step.error.errorId.expiredProgram.buttonText": "查看更多优惠",
  "defaultMessages.step.error.errorId.expiredProgram.title": "优惠已售罄！",
  "defaultMessages.step.error.errorId.inactiveProgram.buttonText": "查看更多优惠",
  "defaultMessages.step.error.errorId.inactiveProgram.title": "优惠已售罄！",
  "defaultMessages.step.error.errorId.ineligibleOrganization.title": "我们无法验证您的资格。",
  "defaultMessages.step.error.errorId.missingRequiredExternalId.note": "注意：使用隐身窗口或隐私窗口可能会影响表单的正常运行。",
  "defaultMessages.step.error.errorId.missingRequiredExternalId.title": "请登录。",
  "defaultMessages.step.error.errorId.missingRequiredMetadata.note": "注意：使用隐身窗口或隐私窗口可能会影响表单的正常运行。",
  "defaultMessages.step.error.errorId.missingRequiredMetadata.title": "请登录。",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.buttonText": "查看更多优惠",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.title": "优惠已售罄！",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.buttonText": "联系支持",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.title": "优惠已暂停！",
  "defaultMessages.step.error.errorId.verificationLimitExceeded.title": "验证次数已超限",
  "defaultMessages.step.error.title": "我们无法继续您的验证",
  "defaultMessages.step.idCheckLoop.continue": "继续",
  "defaultMessages.step.idCheckLoop.countrySelector.title": "签发国家",
  "defaultMessages.step.idCheckLoop.disclaimer": "SheerID 是 {companyName} 的受信任合作伙伴，使用第三方 {serviceType} 来处理我们的身份核查。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.subtitle": "您需要使用配有摄像头的手机或配有网络摄像头的电脑。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.title": "选择您的文件",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.title": "驾驶执照",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.title": "政府身份证",
  "defaultMessages.step.idCheckLoop.docTypes.passport.subtitle": "照片页",
  "defaultMessages.step.idCheckLoop.docTypes.passport.title": "护照",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.subtitle": "正面和背面",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.title": "居留许可",
  "defaultMessages.step.idCheckLoop.regula.addBackImage": "添加身份证背面",
  "defaultMessages.step.idCheckLoop.regula.addFontImage": "添加身份证正面",
  "defaultMessages.step.idCheckLoop.regula.info.subtitle": "驾驶执照、州身份证、护照或居留许可。",
  "defaultMessages.step.idCheckLoop.regula.info.title": "政府签发身份证件的照片",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityError": "图像存在质量问题。请确保图像清晰、光线充足，所有细节均清晰可见。",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityErrorTitle": "我们无法处理您的文件",
  "defaultMessages.step.idCheckLoop.regula.sdk.rejectedImageNextStep": "请重新拍摄并再次上传。",
  "defaultMessages.step.idCheckLoop.regula.sdk.subtitle": "提交您的政府签发身份证件的照片以继续验证。",
  "defaultMessages.step.idCheckLoop.regula.sdk.title": "身份文件上传",
  "defaultMessages.step.idCheckLoop.regula.sdk.uploadAgain": "再次上传",
  "defaultMessages.step.idCheckLoop.regula.submit": "提交",
  "defaultMessages.step.idCheckLoop.regula.terms": "点击「继续」即表示您已阅读、理解并接受 {privacyPolicyLink} 和 {termsOfService}。",
  "defaultMessages.step.idCheckLoop.regula.title": "要继续，我们需要验证您的身份。",
  "defaultMessages.step.idCheckLoop.regula.uploadFileError": "上传您的文件时发生错误。请再试一次。",
  "defaultMessages.step.idCheckLoop.regula.uploadSubtitle": "请确保文件上的信息清晰易读。避免眩光。",
  "defaultMessages.step.idCheckLoop.regula.uploadTitle": "上传政府签发的身份证件",
  "defaultMessages.step.idCheckLoop.steps.docReview.title": "上传身份状态证明",
  "defaultMessages.step.idCheckLoop.steps.idCheck.subtitle": "有效的政府签发文件，例如驾驶执照、州身份证、护照或居留许可。",
  "defaultMessages.step.idCheckLoop.steps.idCheck.title": "拍摄您的政府身份证照片",
  "defaultMessages.step.idCheckLoop.steps.selfie.title": "自拍",
  "defaultMessages.step.idCheckLoop.subtitle": "您需要使用配有摄像头的手机或配有网络摄像头的电脑。",
  "defaultMessages.step.idCheckLoop.terms": "点击「继续」即表示您已阅读、理解并接受 {scanPolicy}、{privacyPolicyLink} 和 {termsOfService}。",
  "defaultMessages.step.idCheckLoop.title": "让我们验证您的身份",
  "defaultMessages.step.override.errors.codeOverrideLimit": "超出覆盖码限制。",
  "defaultMessages.step.override.errors.invalidCode": "无效的覆盖码。",
  "defaultMessages.step.override.submitOverrideCodeButtonLabel": "提交覆盖码",
  "defaultMessages.step.override.subtitle": "如果您在店内进行验证，但没有证明资格的文件或难以上传文件，请联系店内服务人员以确认您的资格。",
  "defaultMessages.step.override.subtitle2": "如果服务人员确认您有资格享受优惠，他们可在下方输入验证覆盖码。",
  "defaultMessages.step.override.title": "无法验证状态",
  "defaultMessages.step.override.verificationOverrideCodeLabel": "验证覆盖码",
  "defaultMessages.step.pending.idCheckLoop.subtitle": "请稍候，处理时间通常需要几分钟或更短。",
  "defaultMessages.step.pending.idCheckLoop.subtitle2": "审核完成后，我们将向您发送电子邮件。",
  "defaultMessages.step.pending.idCheckLoop.title": "我们正在审核您的文件",
  "defaultMessages.step.pending.subtitle": "SheerID 正在审核您的文件以确认您的状态。此流程最多可能需要 {{maxReviewTime}}。",
  "defaultMessages.step.pending.subtitle2": "您可以在此等待或关闭此页面。",
  "defaultMessages.step.pending.subtitle3": "审核完成后，我们会通过电子邮件通知您。",
  "defaultMessages.step.pending.titleReview": "已收到文件",
  "defaultMessages.step.pending.turnaroundTime": "审核通常需要 {{estimatedReviewTime}}，但在繁忙时段可能需要长达 {{maxReviewTime}}。",
  "defaultMessages.step.personalInfo.captcha.error": "无法确认您是真人。请检查您的网络连接、关闭广告拦截器，或刷新页面后再试。",
  "defaultMessages.step.personalInfo.captcha.loading": "正在确认您是真人，请在按钮启用后再次点击「{submitButtonText}」。",
  "defaultMessages.step.personalInfo.captcha.retryButton": "重试",
  "defaultMessages.step.personalInfo.captcha.success": "确认完成，请再次点击「{submitButtonText}」以继续验证。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.closing": "尽情享受吧！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.message": "Verify@sheerid.com 已重新发送您的确认电子邮件，其中包含兑换已验证优惠的详情。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.title": "您以前来过这里！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.needChanges": "需要进行更改？",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.closing": "Verify@sheerid.com 已重新发送最新电子邮件给您，其中包含后续步骤。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.message": "此电子邮件与正在进行的验证相关联。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.title": "看来您已开始。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.proceedHere": "在此继续",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.closing": "Verify@sheerid.com 已重新发送最新电子邮件给您，其中包含后续步骤。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.message": "此电子邮件与正在进行的验证相关联，需要上传另一份文件。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.title": "看来您已开始。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sendAgain": "重新发送",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sent": "已发送！",
  "defaultMessages.step.personalInfo.submitButtonText": "验证并继续",
  "defaultMessages.step.personalInfo.verifyingSubtitle": "这只需要一分钟",
  "defaultMessages.step.personalInfo.verifyingTitle": "正在验证您的状态",
  "defaultMessages.step.smsLoop.errors.codeExpired": "验证码无法验证。",
  "defaultMessages.step.smsLoop.errors.codeResendLimit": "已达到重试次数上限。",
  "defaultMessages.step.smsLoop.errors.codeVerification": "验证码无法验证。",
  "defaultMessages.step.smsLoop.errors.resend": "发送短信时出错",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber1": "号码不正确？点击",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber2": "这里",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber3": "返回 {companyName}",
  "defaultMessages.step.smsLoop.resendButton": "重新发送",
  "defaultMessages.step.smsLoop.submitButton": "提交",
  "defaultMessages.step.smsLoop.successResend": "短信已成功重新发送",
  "defaultMessages.step.smsLoop.titleWithNumber": "我们已向以 {number} 结尾的手机号码发送了短信。请在此输入您的验证码。",
  "defaultMessages.step.smsLoop.titleWithoutNumber": "我们已向您的手机号码发送了短信。请在此输入验证码。",
  "defaultMessages.step.smsLoop.verificationCode": "验证码",
  "defaultMessages.step.sso.alternative": "您也可以通过上传资格证明来完成验证",
  "defaultMessages.step.sso.cancel": "上传文件",
  "defaultMessages.step.sso.login": "登录我的学校",
  "defaultMessages.step.sso.preheader": "最快捷的方式",
  "defaultMessages.step.sso.subtitle": "请登录您学校的网络门户。它将在新标签页中打开。",
  "defaultMessages.step.sso.subtitle2": "无法登录？",
  "defaultMessages.step.sso.title": "使用您的学校凭据进行验证",
  "defaultMessages.step.success.copyCouponCode": "复制优惠券代码",
  "defaultMessages.step.success.emailNotification": "我们已向您发送了含有兑换说明的确认电子邮件。请查看来自 {email} 的电子邮件。",
  "defaultMessages.step.success.rememberMe.consumerFound.button": "保存到\"记住我\"",
  "defaultMessages.step.success.rememberMe.consumerFound.description": "使用 SheerID 的\"记住我\"服务保存新信息，以便享受与 {companyName} 及其他品牌的未来优惠。",
  "defaultMessages.step.success.rememberMe.consumerFound.title": "更新您的个人资料",
  "defaultMessages.step.success.rememberMe.consumerNotFound.button": "立即注册",
  "defaultMessages.step.success.rememberMe.consumerNotFound.description": "使用 SheerID 的\"记住我\"服务，更快速地获取与 {companyName} 及其他品牌的未来优惠。",
  "defaultMessages.step.success.rememberMe.consumerNotFound.title": "保存您的信息以进行一键验证",
  "defaultMessages.step.success.verificationOnly": "SheerID 仅负责验证。现在您已获批准，请将有关促销条款的所有问题直接联系 {companyName} 客户服务。",
  "defaultMessages.step.thirdPartyLoop.error": "不支持此提供商",
  "defaultMessages.step.thirdPartyLoop.signzy.cancel": "上传身份证明",
  "defaultMessages.step.thirdPartyLoop.signzy.login": "登录 DigiLocker",
  "defaultMessages.step.thirdPartyLoop.signzy.subtitle": "使用您的 DigiLocker 登录信息进行验证",
  "defaultMessages.step.thirdPartyLoop.signzy.title": "使用 DigiLocker 进行验证",
  "defaultMessages.streetAddress": "街道地址",
  "defaultMessages.studentInfoShared": "此处输入的信息将用于验证目的，并与 {companyName} 共享。",
  "defaultMessages.tryAgain": "再试一次",
  "defaultMessages.tryFullNameTips": "请尝试输入学术机构的完整名称，而非使用首字母缩写或缩写形式。",
  "defaultMessages.universityName": "大学名称",
  "defaultMessages.verificationPurposesOnly": "仅用于验证目的",
  "defaultMessages.verifyAndContinue": "验证并继续",
  "defaultMessages.verifyMyEmploymentStatus": "验证我的员工状态",
  "defaultMessages.verifyMyFirstResponderStatus": "验证我的急救人员状态",
  "defaultMessages.verifyMyIdentityStatus": "验证我的身份",
  "defaultMessages.verifyMyLicensedProfessionalStatus": "验证我的持证专业人员状态",
  "defaultMessages.verifyMyLowIncomeStatus": "验证我的状态",
  "defaultMessages.verifyMyMedicalProfessionalStatus": "验证我的医疗专业人员状态",
  "defaultMessages.verifyMyMembershipStatus": "验证我的会员状态",
  "defaultMessages.verifyMyMilitaryStatus": "验证我的军事状态",
  "defaultMessages.verifyMyMoverStatus": "验证我的新搬迁者状态",
  "defaultMessages.verifyMyStudentStatus": "验证我的学生状态",
  "defaultMessages.verifyMyTeacherStatus": "验证我的教育工作者状态",
  "defaultMessages.warningId.openOrganization": "我们在数据库中找不到该名称的匹配项。请再次确认拼写，如果正确，请放心继续！",
  "segmentMessages.age.emailExplanation": "建议使用个人电子邮件地址",
  "segmentMessages.age.step.docUpload.title": "若要继续，请上传确认您年龄的文件",
  "segmentMessages.age.step.docUpload.uploadInstructions": "上传一份显示以下内容的政府颁发文件",
  "segmentMessages.age.step.docUpload.whoIsSheerId": "文件审查由 SheerID 负责，SheerID 是专门核实年龄的可信赖合作伙伴。",
  "segmentMessages.age.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此优惠的资格，您必须达到特定年龄。<br><br>{{companyName}} 使用 SheerID（一个可信赖的合作伙伴）来验证您的年龄。SheerID 仅收集有助于验证您资格的信息。可能会要求提供额外信息或文件。",
  "segmentMessages.age.step.personalInfo.submitButtonText": "验证并继续",
  "segmentMessages.age.step.personalInfo.subtitle": "验证您当前的年龄。",
  "segmentMessages.age.step.personalInfo.title": "解锁您的专属优惠",
  "segmentMessages.age.step.personalInfo.tryAgain.subtitle": "您的全名和出生日期必须与您的政府颁发文件上的信息相符。",
  "segmentMessages.age.step.personalInfo.tryAgain.title": "检查您的姓名和出生日期",
  "segmentMessages.age.step.personalInfo.verifyingTitle": "正在验证您的年龄",
  "segmentMessages.age.step.success.redirectButtonText": "继续",
  "segmentMessages.age.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.age.step.success.title": "您已通过验证",
  "segmentMessages.employment.addressExplanation": "使用您的家庭住址",
  "segmentMessages.employment.emailExplanation": "如有工作邮箱，请使用您的工作邮箱",
  "segmentMessages.employment.step.docUpload.title": "如要继续，请上传确认就业状态的文件",
  "segmentMessages.employment.step.docUpload.uploadInstructions": "上传显示以下内容的官方文件",
  "segmentMessages.employment.step.docUpload.whoIsSheerId": "文件审查由 SheerID 负责，SheerID 是专门验证员工的受信任合作伙伴。",
  "segmentMessages.employment.step.personalInfo.howDoesVerifyingWorkDetails": "{{companyName}} 为特定公司的所有现任员工设立了此特别优惠。<br><br>{{companyName}} 使用 SheerID（一个可信赖的合作伙伴）来验证您是否目前受雇。SheerID 仅收集有助于验证您资格的信息。可能会要求提供额外信息或文件。",
  "segmentMessages.employment.step.personalInfo.submitButtonText": "验证我的员工身份",
  "segmentMessages.employment.step.personalInfo.subtitle": "验证您是符合条件公司的现任员工。",
  "segmentMessages.employment.step.personalInfo.title": "解锁此仅限受雇人士的优惠",
  "segmentMessages.employment.step.personalInfo.tryAgain.subtitle": "您提供的信息应与您的官方文件相符。",
  "segmentMessages.employment.step.personalInfo.tryAgain.title": "检查您提供的信息",
  "segmentMessages.employment.step.personalInfo.verifyingTitle": "正在验证您的就业状态",
  "segmentMessages.employment.step.sso.alternative": "您也可以通过上传就业证明进行验证",
  "segmentMessages.employment.step.sso.cancel": "上传就业证明",
  "segmentMessages.employment.step.sso.login": "登录我的邮箱",
  "segmentMessages.employment.step.sso.subtitle": "请登录您公司的邮箱门户。它将在新标签页中打开。",
  "segmentMessages.employment.step.sso.subtitle2": "无法登录您的邮箱？",
  "segmentMessages.employment.step.sso.title": "使用公司提供的电子邮件凭据进行验证",
  "segmentMessages.employment.step.success.redirectButtonText": "继续",
  "segmentMessages.employment.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.employment.step.success.title": "您已通过验证",
  "segmentMessages.firstResponder.emailExplanation": "如有工作邮箱，请使用您的工作邮箱",
  "segmentMessages.firstResponder.step.docUpload.title": "如要继续，请上传确认您急救人员身份的文件",
  "segmentMessages.firstResponder.step.docUpload.uploadInstructions": "上传显示以下内容的官方文件",
  "segmentMessages.firstResponder.step.docUpload.whoIsSheerId": "文件审查由 SheerID 负责，SheerID 是专门验证急救人员的受信任合作伙伴。",
  "segmentMessages.firstResponder.step.personalInfo.howDoesVerifyingWorkDetails": "此优惠适用于所有美国急救人员和应急人员，包括执法人员、急救技术员、辅助医疗人员和消防员。<br><br>{{companyName}} 使用 SheerID（一个可信赖的合作伙伴）来验证您是否为在职急救人员。SheerID 仅收集有助于验证您资格的信息。可能会要求提供额外信息或文件。",
  "segmentMessages.firstResponder.step.personalInfo.submitButtonText": "验证我的急救人员身份",
  "segmentMessages.firstResponder.step.personalInfo.subtitle": "验证您是在职急救人员。",
  "segmentMessages.firstResponder.step.personalInfo.title": "解锁此仅限急救人员的优惠",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.subtitle": "您的全名、组织名称和电子邮件必须与您机构的记录相符。",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.title": "检查您的姓名、电子邮件和组织",
  "segmentMessages.firstResponder.step.personalInfo.verifyingTitle": "正在验证您的急救人员身份",
  "segmentMessages.firstResponder.step.success.redirectButtonText": "继续",
  "segmentMessages.firstResponder.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.firstResponder.step.success.title": "您已通过验证",
  "segmentMessages.identity.emailExplanation": "建议使用个人电子邮件地址",
  "segmentMessages.identity.step.docUpload.title": "如需继续，请上传确认您状态的文件",
  "segmentMessages.identity.step.docUpload.uploadInstructions": "上传政府颁发的文件以显示",
  "segmentMessages.identity.step.docUpload.whoIsSheerId": "文件审查由SheerID处理，SheerID是专门从事状态验证的受信任合作伙伴。",
  "segmentMessages.identity.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此优惠的资格，您必须持有有效的驾驶执照。<br><br>{{companyName}}使用受信任的合作伙伴SheerID来验证您的身份。SheerID只收集有助于验证您资格的信息。可能会要求提供额外的信息或文件。",
  "segmentMessages.identity.step.personalInfo.submitButtonText": "验证我的身份",
  "segmentMessages.identity.step.personalInfo.subtitle": "验证您当前的身份。",
  "segmentMessages.identity.step.personalInfo.title": "解锁您的特别优惠",
  "segmentMessages.identity.step.personalInfo.tryAgain.subtitle": "您的信息必须与政府颁发的文件一致。",
  "segmentMessages.identity.step.personalInfo.tryAgain.title": "检查您的姓名和其他字段",
  "segmentMessages.identity.step.personalInfo.verifyingTitle": "正在验证您的身份",
  "segmentMessages.identity.step.success.redirectButtonText": "继续",
  "segmentMessages.identity.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.identity.step.success.title": "您已通过验证",
  "segmentMessages.licensedProfessional.emailExplanation": "如有工作邮箱，请使用工作邮箱",
  "segmentMessages.licensedProfessional.step.docUpload.title": "如需继续，请上传确认您是持证专业人士的文件",
  "segmentMessages.licensedProfessional.step.docUpload.uploadInstructions": "上传政府颁发的文件以显示",
  "segmentMessages.licensedProfessional.step.docUpload.whoIsSheerId": "文件审查由SheerID处理，SheerID是专门验证持证专业人士的受信任合作伙伴。",
  "segmentMessages.licensedProfessional.step.personalInfo.howDoesVerifyingWorkDetails": "要符合此优惠的资格，您必须在指定领域持有现有的专业执照。此表格的状态选择器中显示了符合条件的领域。<br><br>{{companyName}}使用受信任的合作伙伴SheerID来确认您是持证专业人士。SheerID只收集有助于验证您资格的信息。可能会要求提供额外的信息或文件。",
  "segmentMessages.licensedProfessional.step.personalInfo.submitButtonText": "验证我的持证专业人士身份",
  "segmentMessages.licensedProfessional.step.personalInfo.subtitle": "验证您在您的领域拥有专业执照。",
  "segmentMessages.licensedProfessional.step.personalInfo.title": "解锁此特别优惠",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.subtitle": "您的信息必须与政府颁发的文件一致。",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.title": "检查您的姓名和其他字段",
  "segmentMessages.licensedProfessional.step.personalInfo.verifyingTitle": "正在验证您的执照",
  "segmentMessages.licensedProfessional.step.success.redirectButtonText": "继续",
  "segmentMessages.licensedProfessional.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.licensedProfessional.step.success.title": "您已通过验证",
  "segmentMessages.lowIncome.addressExplanation": "请使用您的家庭住址",
  "segmentMessages.lowIncome.step.docUpload.title": "如需继续，请上传确认您参与已批准政府援助计划的文件",
  "segmentMessages.lowIncome.step.docUpload.uploadInstructions": "上传显示以下信息的官方文件",
  "segmentMessages.lowIncome.step.docUpload.whoIsSheerId": "文件审核由 SheerID 负责，SheerID 是专门核实您资格的可信合作伙伴。",
  "segmentMessages.lowIncome.step.personalInfo.howDoesVerifyingWorkDetails": "要获得此优惠的资格，您目前必须符合合格政府援助计划的条件。此优惠的合格政府援助计划可在下方框中找到。<br><br>{{companyName}} 使用 SheerID（一个可信合作伙伴）来核实您是这些福利的受益人。SheerID 只收集有助于核实您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.lowIncome.step.personalInfo.submitButtonText": "验证我的状态",
  "segmentMessages.lowIncome.step.personalInfo.subtitle": "验证您符合合格政府援助计划的条件。",
  "segmentMessages.lowIncome.step.personalInfo.title": "解锁此特别优惠",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.subtitle": "您的信息必须与政府颁发的文件一致。",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.title": "检查您的全名和其他字段",
  "segmentMessages.lowIncome.step.personalInfo.verifyingTitle": "正在验证您的状态",
  "segmentMessages.lowIncome.step.success.redirectButtonText": "继续",
  "segmentMessages.lowIncome.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.lowIncome.step.success.title": "您已通过验证",
  "segmentMessages.medical.emailExplanation": "如有工作邮箱，请使用工作邮箱",
  "segmentMessages.medical.step.docUpload.title": "如需继续，请上传确认您医疗专业人员身份的文件",
  "segmentMessages.medical.step.docUpload.uploadInstructions": "上传显示以下信息的官方文件",
  "segmentMessages.medical.step.docUpload.whoIsSheerId": "文件审核由 SheerID 负责，SheerID 是专门核实您作为医疗专业人员资格的可信合作伙伴。",
  "segmentMessages.medical.step.personalInfo.howDoesVerifyingWorkDetails": "要获得此优惠的资格，您必须是持牌及认证的医疗专业人员。这包括医生、护士、药剂师及其他医疗专业人员。<br><br>{{companyName}} 使用 SheerID（一个可信合作伙伴）来核实您的医疗专业人员身份。SheerID 只收集有助于核实您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.medical.step.personalInfo.submitButtonText": "验证我的医疗专业人员状态",
  "segmentMessages.medical.step.personalInfo.subtitle": "验证您作为持牌医疗专业人员的身份。",
  "segmentMessages.medical.step.personalInfo.title": "解锁此专属医疗专业人员优惠",
  "segmentMessages.medical.step.personalInfo.tryAgain.subtitle": "您的姓名、出生日期和机构必须与我们的记录相符",
  "segmentMessages.medical.step.personalInfo.tryAgain.title": "请确认您的姓名、出生日期和机构正确无误",
  "segmentMessages.medical.step.personalInfo.verifyingTitle": "正在验证您的医疗专业人员状态",
  "segmentMessages.medical.step.sso.alternative": "您也可以通过雇主门户进行验证",
  "segmentMessages.medical.step.sso.login": "登录雇主门户",
  "segmentMessages.medical.step.sso.subtitle": "使用您机构的凭证来验证您的状态",
  "segmentMessages.medical.step.sso.title": "验证医疗保健专业人员状态",
  "segmentMessages.medical.step.success.redirectButtonText": "继续",
  "segmentMessages.medical.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.medical.step.success.title": "您已通过验证",
  "segmentMessages.member.step.docUpload.title": "如需继续，请上传确认您在合格组织中会员资格的文件",
  "segmentMessages.member.step.docUpload.uploadInstructions": "上传显示以下信息的官方文件",
  "segmentMessages.member.step.docUpload.whoIsSheerId": "文件审核由 SheerID 负责，SheerID 是专门核实您作为会员资格的可信合作伙伴。",
  "segmentMessages.member.step.personalInfo.howDoesVerifyingWorkDetails": "要获得此优惠的资格，您必须是合格组织的有效会员。此优惠的合格组织可在下方框中找到。<br><br>{{companyName}} 使用 SheerID（一个可信合作伙伴）来核实您的会员资格。SheerID 只收集有助于核实您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.member.step.personalInfo.submitButtonText": "验证我的会员状态",
  "segmentMessages.member.step.personalInfo.subtitle": "验证您在合格组织中的有效会员资格。",
  "segmentMessages.member.step.personalInfo.title": "解锁此专属会员优惠",
  "segmentMessages.member.step.personalInfo.tryAgain.subtitle": "您的信息必须与组织的官方记录相符",
  "segmentMessages.member.step.personalInfo.tryAgain.title": "请确认所提供的信息正确无误",
  "segmentMessages.member.step.personalInfo.verifyingTitle": "正在验证您的会员资格",
  "segmentMessages.member.step.success.redirectButtonText": "继续",
  "segmentMessages.member.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.member.step.success.title": "您已通过验证",
  "segmentMessages.military.emailExplanation": "建议使用个人电子邮件地址",
  "segmentMessages.military.step.docUpload.title": "如需继续，请上传确认您军事身份的文件",
  "segmentMessages.military.step.docUpload.uploadInstructions": "上传您的政府颁发文件以显示",
  "segmentMessages.military.step.docUpload.whoIsSheerId": "文件审核由 SheerID 负责，SheerID 是专门核实您作为军人资格的可信合作伙伴。",
  "segmentMessages.military.step.personalInfo.howDoesVerifyingWorkDetails": "要获得此优惠的资格，您必须是现役、退役或退伍军人。这包括现役军人、后备军人、退伍军人及其家属。<br><br>{{companyName}} 使用 SheerID（一个可信合作伙伴）来核实您的军事身份。SheerID 只收集有助于核实您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.military.step.personalInfo.submitButtonText": "验证我的军事状态",
  "segmentMessages.military.step.personalInfo.subtitle": "验证您作为现役、退役或退伍军人的身份。",
  "segmentMessages.military.step.personalInfo.title": "解锁此专属军人优惠",
  "segmentMessages.military.step.personalInfo.tryAgain.subtitle": "请确认您的姓名、出生日期和军种正确无误",
  "segmentMessages.military.step.personalInfo.tryAgain.title": "检查您的姓名和出生日期",
  "segmentMessages.military.step.personalInfo.verifyingTitle": "正在验证您的军事状态",
  "segmentMessages.military.step.success.redirectButtonText": "继续",
  "segmentMessages.military.step.success.subtitle": "您现在有资格享受此特别优惠。",
  "segmentMessages.military.step.success.title": "您已通过验证",
  "segmentMessages.recentMover.emailExplanation": "建议使用个人电子邮件地址",
  "segmentMessages.recentMover.step.docUpload.title": "如需继续，请上传确认您最近搬迁的文件",
  "segmentMessages.recentMover.step.docUpload.uploadInstructions": "请上传显示以下内容的官方文件",
  "segmentMessages.recentMover.step.docUpload.whoIsSheerId": "文件审查由SheerID负责，SheerID是专门核实近期搬迁者的可信赖合作伙伴。",
  "segmentMessages.recentMover.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此优惠的资格，您必须在过去60天内搬迁至新地址。<br><br>{{companyName}}使用SheerID（值得信赖的合作伙伴）验证您是否最近已搬迁。SheerID仅收集有助于验证您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.recentMover.step.personalInfo.submitButtonText": "验证我的新搬迁状态",
  "segmentMessages.recentMover.step.personalInfo.subtitle": "验证您最近已搬迁。",
  "segmentMessages.recentMover.step.personalInfo.title": "解锁此特别优惠",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.subtitle": "您的名字、姓氏及地址必须与您的正式文件上的内容相符。",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.title": "确认您的姓名和地址信息",
  "segmentMessages.recentMover.step.personalInfo.verifyingTitle": "正在验证您的搬迁状态",
  "segmentMessages.recentMover.step.success.redirectButtonText": "继续",
  "segmentMessages.recentMover.step.success.subtitle": "您现在符合此特别优惠的资格。",
  "segmentMessages.recentMover.step.success.title": "您已通过验证",
  "segmentMessages.senior.emailExplanation": "建议使用个人电子邮件地址",
  "segmentMessages.senior.step.docUpload.title": "如需继续，请上传确认您年龄的文件",
  "segmentMessages.senior.step.docUpload.uploadInstructions": "请上传政府签发的文件，显示",
  "segmentMessages.senior.step.docUpload.whoIsSheerId": "文件审查由SheerID负责，SheerID是专门核实年龄的可信赖合作伙伴。",
  "segmentMessages.senior.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此优惠的资格，您必须达到特定年龄。<br><br>{{companyName}}使用SheerID（值得信赖的合作伙伴）验证您的年龄。SheerID仅收集有助于验证您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.senior.step.personalInfo.submitButtonText": "验证并继续",
  "segmentMessages.senior.step.personalInfo.subtitle": "验证您当前的年龄。",
  "segmentMessages.senior.step.personalInfo.title": "解锁您的特别优惠",
  "segmentMessages.senior.step.personalInfo.tryAgain.subtitle": "您的全名及出生日期必须与您的政府颁发文件上的内容相符。",
  "segmentMessages.senior.step.personalInfo.tryAgain.title": "确认您的姓名和出生日期",
  "segmentMessages.senior.step.personalInfo.verifyingTitle": "正在验证您的年龄",
  "segmentMessages.senior.step.success.redirectButtonText": "继续",
  "segmentMessages.senior.step.success.subtitle": "您现在符合此特别优惠的资格。",
  "segmentMessages.senior.step.success.title": "您已通过验证",
  "segmentMessages.student.emailExplanation": "建议使用学生电子邮件地址",
  "segmentMessages.student.schoolName": "学校",
  "segmentMessages.student.step.docUpload.title": "若要继续，请上传一份或多份确认您学生身份的文件。",
  "segmentMessages.student.step.docUpload.uploadInstructions": "请上传您学校发出的文件，显示",
  "segmentMessages.student.step.docUpload.whoIsSheerId": "文件审查由SheerID负责，SheerID是专门核实学生身份的可信赖合作伙伴。",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.alternative": "无法访问学术电子邮件地址？",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.email.label": "学术电子邮件地址",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.subtitle": "输入您的学术机构提供的电子邮件地址，我们将向您发送验证链接",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.title": "使用您的学术电子邮件地址验证",
  "segmentMessages.student.step.emailLoop.errors.invalidEmail": "此电子邮件地址不适用于即时验证。请使用您的学术机构提供的电子邮件地址或在下方上传文件。",
  "segmentMessages.student.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此优惠的资格，您必须目前在具有学位或证书授予资格的认可教育学校就读。<br><br>{{companyName}}使用SheerID（值得信赖的合作伙伴）验证您是在校学生。SheerID仅收集有助于验证您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.student.step.personalInfo.submitButtonText": "验证我的学生身份",
  "segmentMessages.student.step.personalInfo.subtitle": "验证您是颁授学位学校的学生。",
  "segmentMessages.student.step.personalInfo.title": "解锁此学生专属优惠",
  "segmentMessages.student.step.personalInfo.tryAgain.subtitle": "您的全名及出生日期必须与您的官方学校记录相符。",
  "segmentMessages.student.step.personalInfo.tryAgain.title": "确认您的姓名和出生日期",
  "segmentMessages.student.step.personalInfo.verifyingTitle": "正在验证您的学生身份",
  "segmentMessages.student.step.sso.alternative": "您也可以通过上传入学证明来验证",
  "segmentMessages.student.step.sso.cancel": "上传入学证明",
  "segmentMessages.student.step.sso.login": "登录我的学术机构",
  "segmentMessages.student.step.sso.subtitle": "登录您的学术机构以验证您当前的注册状态。您的学校门户将在新窗口中打开。",
  "segmentMessages.student.step.sso.title": "使用您的学校登录信息进行验证",
  "segmentMessages.student.step.success.redirectButtonText": "继续",
  "segmentMessages.student.step.success.subtitle": "您现在符合此特别优惠的资格。",
  "segmentMessages.student.step.success.title": "您已通过验证",
  "segmentMessages.teacher.emailExplanation": "必须是您学校发出的电子邮件地址",
  "segmentMessages.teacher.schoolName": "学校名称",
  "segmentMessages.teacher.schoolNamePlaceholder": "学校名称",
  "segmentMessages.teacher.step.docUpload.title": "如需继续，请上传确认您教育工作者身份的文件",
  "segmentMessages.teacher.step.docUpload.uploadInstructions": "请上传您学校发出的文件，显示",
  "segmentMessages.teacher.step.docUpload.whoIsSheerId": "文件审查由SheerID负责，SheerID是专门核实教育工作者身份的可信赖合作伙伴。",
  "segmentMessages.teacher.step.personalInfo.howDoesVerifyingWorkDetails": "若要符合此优惠的资格，您必须目前在认可教育机构担任教育工作者、教职员或员工。<br><br>{{companyName}}使用SheerID（值得信赖的合作伙伴）验证您是现任教育工作者、教职员或员工。SheerID仅收集有助于验证您资格的信息。可能会要求提供其他信息或文件。",
  "segmentMessages.teacher.step.personalInfo.submitButtonText": "验证我的教育工作者身份",
  "segmentMessages.teacher.step.personalInfo.subtitle": "验证您是认可教育机构的教育工作者、教职员或员工。",
  "segmentMessages.teacher.step.personalInfo.title": "解锁此教育工作者专属优惠",
  "segmentMessages.teacher.step.personalInfo.tryAgain.subtitle": "您的全名及电子邮件地址必须与您学校记录的内容相符。",
  "segmentMessages.teacher.step.personalInfo.tryAgain.title": "确认您的姓名和电子邮件",
  "segmentMessages.teacher.step.personalInfo.verifyingTitle": "正在验证您的教育工作者身份",
  "segmentMessages.teacher.step.success.redirectButtonText": "继续",
  "segmentMessages.teacher.step.success.subtitle": "您现在符合此特别优惠的资格。",
  "segmentMessages.teacher.step.success.title": "您已通过验证",
  "segmentMessages.student.step.personalInfo.nameInstructions": "请准确输入您在正式学校记录上显示的姓名。",
  "segmentMessages.student.step.docUpload.uploadInfo.fullName": "您在学校记录上显示的<strong>全名</strong>",
  "defaultMessages.step.pending.uploadedDocument": "您的文件已成功上传，正在审核中。",
  "defaultMessages.step.docUpload.uploadInfo.expiration": "尚未过期的到期日",
  "defaultMessages.step.docUpload.uploadInfo.issueDate": "过去 90 天内的签发日期",
  "defaultMessages.step.docUpload.uploadInfo.enrollmentProof": "<strong>当前注册</strong>的证明，以下列其中一项显示：",
  "defaultMessages.contactSupport": "如果您认为自己符合条件，请查看我们的<faqLink>帮助中心</faqLink>或<feedbackFormLink>联系 SheerID 支持团队</feedbackFormLink>"
}
